import {
    createBrowserRouter,
    Navigate,
    Outlet,
} from "react-router-dom";
import Designer from "./pages/app/Designer/Designer";
import SignIn from "./pages/auth/SignIn";
import { Error404 } from "./pages/Error404";
import { NavBar } from "./components/NavBar";
import Dashboard from "./pages/app/Dashboard.tsx";
import { useAuth } from "./context/auth/useAuth.ts";
import Splashscreen from "./components/Splashscreen.tsx";
import Upgrade from "./pages/Upgrade.tsx";

const PrivateRoute = () => {
    const { user, license, isLoading } = useAuth();

    if (isLoading) return <Splashscreen />;

    if (license === "free") {
        return <Navigate to="/upgrade" replace />;
    }

    if (!user && !license) return <Navigate to="/login" replace />;

    return (
        <NavBar user={user}>
            <Outlet />
        </NavBar>
    );
};

const PublicWrapper = ({ children }: { children: React.ReactElement }) => {
    const { user } = useAuth()
    return (
        <NavBar user={user}>
            {children}
        </NavBar>
    );
};

const router = createBrowserRouter([
    {
        path: "/login",
        element: (
            <PublicWrapper>
                <SignIn />
            </PublicWrapper>
        ),
    },
    {
        path: "/",
        element: <PrivateRoute />,
        children: [
            { index: true, element: <Dashboard/> },
            { path: "designer", element: <Designer /> },
        ],
    },
    {
        path: "/upgrade",
        element: (
            <PublicWrapper>
                <Upgrade/>
            </PublicWrapper>
        ),
    },
    {
        path: "*",
        element: (
            <PublicWrapper>
                <Error404 />
            </PublicWrapper>
        ),
    },
]);
export default router;
